import { AtlasRegionDTO } from '@/types/atlas/AtlasRegionDTO';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@/app/store';

export interface HelpState {
  region: AtlasRegionDTO | null;
}

const initialState: HelpState = {
  region: null,
};

export const helpSlice = createSlice({
  name: 'help',
  initialState: initialState,
  reducers: {
    setAtlasRegion: (state: HelpState, action: PayloadAction<AtlasRegionDTO | null>): void => {
      state.region = action.payload;
    },
  },
});

export const { setAtlasRegion } = helpSlice.actions;

export const getRegion = (state: RootState): AtlasRegionDTO | null => {
  return state?.help?.region ?? initialState.region;
};

export default helpSlice.reducer;
